/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstructionReminderOccurrenceDto
 */
export interface InstructionReminderOccurrenceDto {
    /**
     * Reminder occurrence ID
     * @type {string}
     * @memberof InstructionReminderOccurrenceDto
     */
    id: string;
    /**
     * Reminder schedule ID
     * @type {string}
     * @memberof InstructionReminderOccurrenceDto
     */
    scheduleId: string;
    /**
     * Scheduled UTC timestamp
     * @type {Date}
     * @memberof InstructionReminderOccurrenceDto
     */
    scheduledAtUtc: Date;
    /**
     * Reminder title
     * @type {string}
     * @memberof InstructionReminderOccurrenceDto
     */
    title: string;
    /**
     * Reminder body
     * @type {string}
     * @memberof InstructionReminderOccurrenceDto
     */
    body: string;
    /**
     * Reminder occurrence status
     * @type {string}
     * @memberof InstructionReminderOccurrenceDto
     */
    status: InstructionReminderOccurrenceDtoStatusEnum;
    /**
     * Claimed timestamp
     * @type {object}
     * @memberof InstructionReminderOccurrenceDto
     */
    claimedAt?: object;
    /**
     * Related notification log ID
     * @type {object}
     * @memberof InstructionReminderOccurrenceDto
     */
    notificationLogId?: object;
    /**
     * Sent timestamp
     * @type {object}
     * @memberof InstructionReminderOccurrenceDto
     */
    sentAt?: object;
    /**
     * Failed timestamp
     * @type {object}
     * @memberof InstructionReminderOccurrenceDto
     */
    failedAt?: object;
    /**
     * Failure reason
     * @type {object}
     * @memberof InstructionReminderOccurrenceDto
     */
    failureReason?: object;
    /**
     * Created timestamp
     * @type {Date}
     * @memberof InstructionReminderOccurrenceDto
     */
    createdAt: Date;
    /**
     * Updated timestamp
     * @type {Date}
     * @memberof InstructionReminderOccurrenceDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const InstructionReminderOccurrenceDtoStatusEnum = {
    Pending: 'pending',
    Claimed: 'claimed',
    Sent: 'sent',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;
export type InstructionReminderOccurrenceDtoStatusEnum = typeof InstructionReminderOccurrenceDtoStatusEnum[keyof typeof InstructionReminderOccurrenceDtoStatusEnum];


/**
 * Check if a given object implements the InstructionReminderOccurrenceDto interface.
 */
export function instanceOfInstructionReminderOccurrenceDto(value: object): value is InstructionReminderOccurrenceDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('scheduleId' in value) || value['scheduleId'] === undefined) return false;
    if (!('scheduledAtUtc' in value) || value['scheduledAtUtc'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function InstructionReminderOccurrenceDtoFromJSON(json: any): InstructionReminderOccurrenceDto {
    return InstructionReminderOccurrenceDtoFromJSONTyped(json, false);
}

export function InstructionReminderOccurrenceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstructionReminderOccurrenceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'scheduleId': json['scheduleId'],
        'scheduledAtUtc': (new Date(json['scheduledAtUtc'])),
        'title': json['title'],
        'body': json['body'],
        'status': json['status'],
        'claimedAt': json['claimedAt'] == null ? undefined : json['claimedAt'],
        'notificationLogId': json['notificationLogId'] == null ? undefined : json['notificationLogId'],
        'sentAt': json['sentAt'] == null ? undefined : json['sentAt'],
        'failedAt': json['failedAt'] == null ? undefined : json['failedAt'],
        'failureReason': json['failureReason'] == null ? undefined : json['failureReason'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function InstructionReminderOccurrenceDtoToJSON(json: any): InstructionReminderOccurrenceDto {
    return InstructionReminderOccurrenceDtoToJSONTyped(json, false);
}

export function InstructionReminderOccurrenceDtoToJSONTyped(value?: InstructionReminderOccurrenceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'scheduleId': value['scheduleId'],
        'scheduledAtUtc': ((value['scheduledAtUtc']).toISOString()),
        'title': value['title'],
        'body': value['body'],
        'status': value['status'],
        'claimedAt': value['claimedAt'],
        'notificationLogId': value['notificationLogId'],
        'sentAt': value['sentAt'],
        'failedAt': value['failedAt'],
        'failureReason': value['failureReason'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

